import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environmentProductos } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BrandService {
    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get<any>(`${environmentProductos.apiUrl}/Brand/Get`);
    }
    
    insertBrand(name: string) {

        let json = {BrandName: name};
        return this.http.post<any>(`${environmentProductos.apiUrl}/Brand/InsertOrUpdate`,json );
    }

   
}